type Product = {
  id: number
  name: string
  image: string
  disabled: boolean
}

/**
 * months: [ { products: [ {}, {}, {} ] }, { products: [ {}, {}, {} ] }, ... ]
 * return products: [ {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, ... ]
 */
const getAllQueueProductsArray = <T extends Product>(months: { products: T[] }[] = [], withoutEmpty?: boolean): T[] => {
  const allProducts: T[] = months.reduce((arr: T[], { products }) => [ ...arr, ...products ], [])

  if (withoutEmpty) {
    return allProducts.filter((product) => product && product.id)
  }

  return allProducts
}


export default getAllQueueProductsArray
